export const sampleEmailData ={
    "data": {
        "input": "Write a friendly, informative email sharing the latest blog post, product tip, or industry insight. Make it engaging, helpful, and subtly remind the reader about our brand value.",
        "email_msg": [
            {
                "contact": {
                    "name": "Tor Myhren",
                    "title": "Vice President, Marketing Communications",
                    "department": "Marketing Communications",
                    "email": "tor.myhren@apple.com",
                    "company_name": "Apple",
                    "evaluation": "yes"
                },
                "email_msg": "Subject: Transforming Events with Data-Driven Insights\n\nHi Tor,\n\nI hope this message finds you well. As Apple's Vice President of Marketing Communications, you're likely always on the lookout for innovative ways to enhance marketing strategies and communications. I wanted to share a recent blog post from Cvent that delves into how data-driven insights can transform your event experiences.\n\nOur post explores the latest trends in leveraging data to create more engaging and measurable event experiences, whether they are in-person, virtual, or hybrid. Given your interest in maximizing event ROI and creating seamless attendee experiences, I believe you'll find the insights particularly valuable.\n\nAt Cvent, we aim to make every event count by enabling full control and engagement, from registration to ROI reporting. I think this aligns well with your goals at Apple to continuously drive impactful marketing strategies.\n\nFeel free to reach out if you have any questions or need further information. I'm always here to help!\n\nBest Regards,  \nEmily"
            },
            {
                "contact": {
                    "name": "Greg Joswiak",
                    "title": "Senior Vice President, Worldwide Marketing",
                    "department": "Worldwide Marketing",
                    "email": "greg.joswiak@apple.com",
                    "company_name": "Apple",
                    "evaluation": "yes"
                },
                "email_msg": "Subject: Elevate Your Events with Our Latest Insights\n\nHi Greg,\n\nI hope this message finds you well and thriving at Apple. As the Senior Vice President of Worldwide Marketing, I know how crucial it is to stay ahead with the latest industry insights. We’ve just published a new blog post that I believe you'll find immensely valuable.\n\nOur latest article dives into innovative strategies for transforming events into data-driven experiences, a topic that aligns with your expertise in leading marketing initiatives. The piece offers actionable tips on leveraging technology for seamless event management and maximizing ROI, which could be particularly beneficial for your team as you plan future events.\n\nAt Cvent, we’re dedicated to helping leaders like you plan smarter, engage deeper, and report better on your event outcomes. We understand the importance of having full control and scalability, especially when managing more than 10 events annually as your department might do.\n\nFeel free to explore the blog and share your thoughts. We're here to support Apple in making every event count.\n\nBest Regards,  \nEmily"
            },
            {
                "contact": {
                    "name": "Alice Carlson",
                    "title": "VP Global Marketing",
                    "department": "Marketing",
                    "email": "alice.carlson@oracle.com",
                    "company_name": "Oracle",
                    "evaluation": "yes"
                },
                "email_msg": "Subject: Transform Your Events with Our Latest Insights\n\nHi Alice,\n\nI trust this email finds you well. As the VP of Global Marketing at Oracle, your focus on innovation and strategic marketing likely keeps you quite busy. That's why I wanted to share something that could make a genuine difference in your event planning and management.\n\nWe've just released a new blog post that delves into the latest trends in event management, especially how leveraging data can transform events into engaging and measurable experiences. Given Oracle's commitment to cutting-edge technology, I believe this insight could align with your goals for enhancing event engagement and ROI reporting.\n\nAt Cvent, we empower marketing leaders like you to plan smarter, engage deeper, and report better. Our tools are designed to provide full control over every aspect of your events, whether they're in-person, virtual, or hybrid.\n\nFeel free to check out the blog post and see how Cvent could complement Oracle's marketing strategies. We are here to help ensure every event you host is a success and truly counts.\n\nLooking forward to hearing your thoughts!\n\nBest Regards,  \nEmily"
            },
            {
                "contact": {
                    "name": "Nancy Allen",
                    "title": "VP Product Marketing",
                    "department": "Marketing",
                    "email": "nancy.allen@oracle.com",
                    "company_name": "Oracle",
                    "evaluation": "yes"
                },
                "email_msg": "Subject: Transform Your Event Strategy with Our Latest Insights\n\nHi Nancy,\n\nI hope this email finds you well. As the VP of Product Marketing at Oracle, I know how crucial it is to stay ahead with strategies that not only engage but also drive measurable outcomes.\n\nI wanted to share our latest blog post that delves into innovative strategies for creating data-driven event experiences. Given Oracle's commitment to excellence and innovation, I'm certain you'll find these insights valuable as you continue to lead impactful marketing initiatives.\n\nAt Cvent, we believe in making every event count. Our solutions help transform events into engaging and measurable experiences, whether they're in-person, virtual, or hybrid. With tools for everything from registration to ROI reporting, we enable you to plan smarter, engage deeper, and report better.\n\nI hope you find the blog insightful and feel free to reach out if you have any questions or need further information.\n\nBest Regards,\nEmily"
            },
            {
                "contact": {
                    "name": "Rocky Mitarai",
                    "title": "Vice President Product Marketing",
                    "department": "Marketing",
                    "email": "rocky.mitarai@oracle.com",
                    "company_name": "Oracle",
                    "evaluation": "yes"
                },
                "email_msg": "Subject: Transform Your Product Marketing with Our Latest Insights\n\nHi Rocky,\n\nI hope this message finds you well. I’m reaching out to share an insightful blog post that I believe will resonate with your role as Vice President of Product Marketing at Oracle.\n\nOur latest article delves into the evolving landscape of event marketing and how data-driven strategies can significantly enhance your event outcomes. As Oracle continues to lead in the tech industry, leveraging these insights could provide even more value to your already impressive marketing efforts.\n\nOne key takeaway is the importance of seamless integration between in-person and virtual events. By optimizing your approach, you can ensure that every Oracle event is not just engaging but also measurable, aligning perfectly with our goal to help businesses \"Make Every Event Count.\"\n\nFeel free to explore more about how Cvent can support your team in transforming your events into impactful, data-rich experiences. Whether it's through smarter planning or better engagement, we're here to help you plan smarter and report better.\n\nLooking forward to hearing your thoughts!\n\nBest Regards,  \nEmily"
            }
        ],
        "email_type": 3,
        "style_data": "“Cvent transforms events into measurable, data-driven experiences — whether in-person, virtual, or hybrid. From registration to ROI reporting, Cvent enables full control, scale, and engagement.”\n\nTagline Options:\n\nMake Every Event Count\n\nPlan Smarter. Engage Deeper. Report Better.\n\nMessaging Cheatsheet by Persona\n\nCvent Sales Playbook & Battlecard Content Guideline\nIdeal Customer Profile (ICP)\n\nPrimary Target Segments:\n\n\nKey Criteria to Identify ICP:\n\nHosts more than 10 events annually\nManual or fragmented event registration systems\nUses Excel/email for attendee tracking\nHas a centralized marketing/events team\nValues event ROI reporting\n\nPersonas & Messaging\n\nTop Use Cases\n\nCompetitive Battlecard Summary\n\nPositioning & Messaging Framework\nAnchor Message:",
        "contact_data": [
            {
                "name": "Tor Myhren",
                "title": "Vice President, Marketing Communications",
                "department": "Marketing Communications",
                "email": "tor.myhren@apple.com",
                "company_name": "Apple",
                "evaluation": "yes"
            },
            {
                "name": "Greg Joswiak",
                "title": "Senior Vice President, Worldwide Marketing",
                "department": "Worldwide Marketing",
                "email": "greg.joswiak@apple.com",
                "company_name": "Apple",
                "evaluation": "yes"
            },
            {
                "name": "Tracey Hannelly",
                "title": "Vice President, Apple Retail Engagement, Marketing and Merchandising",
                "department": "Retail Engagement, Marketing and Merchandising",
                "email": "tracey.hannelly@apple.com",
                "company_name": "Apple",
                "evaluation": "no"
            },
            {
                "name": "Michael Lopp",
                "title": "Vice President of Engineering",
                "department": "Engineering",
                "email": "michael.lopp@apple.com",
                "company_name": "Apple",
                "evaluation": "no"
            },
            {
                "name": "Alice Carlson",
                "title": "VP Global Marketing",
                "department": "Marketing",
                "email": "alice.carlson@oracle.com",
                "company_name": "Oracle",
                "evaluation": "yes"
            },
            {
                "name": "Nancy Allen",
                "title": "VP Product Marketing",
                "department": "Marketing",
                "email": "nancy.allen@oracle.com",
                "company_name": "Oracle",
                "evaluation": "yes"
            },
            {
                "name": "Rocky Mitarai",
                "title": "Vice President Product Marketing",
                "department": "Marketing",
                "email": "rocky.mitarai@oracle.com",
                "company_name": "Oracle",
                "evaluation": "yes"
            },
            {
                "name": "Yogesh Kumar",
                "title": "VP Engineering, Oracle Integration",
                "department": "Oracle Integration",
                "email": "yogesh.kumar@oracle.com",
                "company_name": "Oracle",
                "evaluation": "no"
            },
            {
                "name": "Lisa Hornschemeier",
                "title": "Vice President, OCI Engineering",
                "department": "OCI Engineering",
                "email": "lisa.hornschemeier@oracle.com",
                "company_name": "Oracle",
                "evaluation": "no"
            },
            {
                "name": "Conrad Hauser",
                "title": "VP Engineering",
                "department": "Engineering",
                "email": "conrad.hauser@oracle.com",
                "company_name": "Oracle",
                "evaluation": "no"
            },
            {
                "name": "Sumeet Rana",
                "title": "VP Engineering",
                "department": "Engineering",
                "email": "sumeet@growthnatives.com",
                "company_name": "Growth Natives",
                "evaluation": "no"
            }
        ],
        "org_id": 989699,
        "segment": "Audience_50",
        "sender_name": "Emily",
        "email_criteria": "Marketing Nurture",
        "objective": "Keep-in-Touch / Top of Mind Nurture",
        "email_name": "Draft_1"
    },
    "contact_names": [
        "Tor Myhren",
        "Greg Joswiak",
        "Alice Carlson",
        "Nancy Allen",
        "Rocky Mitarai"
    ],
    "company_names": [
        "Oracle",
        "Apple"
    ],
    "contact_emails": [
        "tor.myhren@apple.com",
        "greg.joswiak@apple.com",
        "alice.carlson@oracle.com",
        "nancy.allen@oracle.com",
        "rocky.mitarai@oracle.com"
    ],
    "total_emails": 5,
    "message": "Success"
}
